import { render, staticRenderFns } from "./dataIndex.vue?vue&type=template&id=76a97cd4&scoped=true&"
import script from "./dataIndex.vue?vue&type=script&lang=js&"
export * from "./dataIndex.vue?vue&type=script&lang=js&"
import style0 from "./dataIndex.vue?vue&type=style&index=0&id=76a97cd4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76a97cd4",
  null
  
)

export default component.exports